import * as _ from 'lodash';
export const ConvertSelectObjectToValue = (field, data) => {
  if (typeof (data[field]) === 'object')
    return _.get(data, `${field}.value`);
  else
    return _.get(data, field) || undefined;
}